import React from "react";
import { defineMessages } from "react-intl";
import { ButtonLink, FullButtonLinkProps } from "./ButtonLink";
import { FormattedMessage } from "./FormattedMessage";

const messages = defineMessages({
  bookNow: {
    id: "Hero.bookNow",
    defaultMessage: "Book now",
  },
});

type Props = { href: string } & FullButtonLinkProps;

export default function BookNowButton({ href, ...rest }: Props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <ButtonLink href={href} {...rest}>
      <FormattedMessage message={messages.bookNow} />
    </ButtonLink>
  );
}
